import { Button, Spinner } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { showToast } from "../ShowToast/ToastNotification";
import { useNavigate } from "react-router-dom";

const EditComplianceCampaign = ({ id }) => {
  const [policyId] = useState(id);
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [arabicError, setArabicError] = useState("");

  const [policyTypes, setPolicyTypes] = useState([]);

  const [formData, setFormData] = useState({
    title_en: "",
    title_ar: "",
    description_en: "",
    description_ar: "",
    start_time: "",
    type: "",
    end_date: "",
    start_date: "",
  });

  useEffect(() => {
    fetchPolicyTypes();
    fetchComplianceCampaign();
  }, []);

  const fetchPolicyTypes = async () => {
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(`${api_url}/compliance-campaign-types`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401 || response.status === 403) {
        showToast(t("SessionExpiredPleaseLoginAgain"), "error");
        localStorage.removeItem("userToken");
        navigate("/login");
        return;
      }

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

      const result = await response.json();
      setPolicyTypes(result.data || result);
    } catch (error) {
      showToast(t("errorFetchingData"), "error");
    }
  };

  const fetchComplianceCampaign = async () => {
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/compliance-campaigns/${policyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        showToast(t("errorFetchingComplianceCampaignDetails"), "error");
        return;
      }

      const res = await response.json();

      setFormData({
        title_en: res.data.title_en || "",
        title_ar: res.data.title_ar || "",
        description_en: res.data.description_en || "",
        description_ar: res.data.description_ar || "",
        start_time: res.data.start_time || "",
        type: res.data.type || "",
        start_date: res.data.start_date ? res.data.start_date.slice(0, 10) : "",
        end_date: res.data.end_date ? res.data.end_date.slice(0, 10) : "",
      });
      
    } catch (err) {
      showToast(t("somethingWentWrong"), "error");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleArabicChange = (e) => {
    const { name, value } = e.target;
    // Allow Arabic letters, Arabic/English numbers, and spaces
    const arabicAndNumbersRegex = /^[\u0600-\u06FF0-9\s]+$/;

    if (value === "" || arabicAndNumbersRegex.test(value)) {
      setFormData({ ...formData, [name]: value });
      setArabicError(""); // Clear error
    } else {
      setArabicError(t("Please type in Arabic letters or numbers only."));
    }
  };
  const handleUpdateComplianceCampaign = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const token = localStorage.getItem("userToken");

      const body = {
        title_en: formData.title_en,
        title_ar: formData.title_ar,
        start_date: formData.start_date,
        end_date: formData.end_date,
        description_en: formData.description_en,
        description_ar: formData.description_ar,
        start_time: formData.start_time,
        type: formData.type,
      };

      const response = await fetch(`${api_url}/compliance-campaigns/${policyId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorResult = await response.json();
        if (errorResult?.errors) {
          Object.values(errorResult.errors).forEach((messages) => {
            messages.forEach((msg) => showToast(msg, "error"));
            
          });
        } else {
          showToast(t("failedToUpdateComplianceCampaign"), "error");
        }
      }
      
    } catch (error) {
      showToast(t("somethingWentWrong"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
  className="editPolicyContainer"
  style={{
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    padding: "26px 26px",
    margin: "20px",
  }}
>
  <form onSubmit={handleUpdateComplianceCampaign} className="EditPolicy">
    <div className="row">
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("Title(English)")}</label>
        <input
          type="text"
          name="title_en"
          className="form-control"
          onChange={handleChange}
          value={formData.title_en}
          required
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("Title(Arabic)")}</label>
        <input
          type="text"
          name="title_ar"
          className="form-control"
          onChange={handleArabicChange}
          value={formData.title_ar}
          required
        />
           {arabicError && (
                                    <div className="text-danger mt-1" style={{ fontSize: "0.9em" }}>
                                    {arabicError}
                                    </div>
                                )}
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("description_en")}</label>
        <input
          type="text"
          name="description_en"
          className="form-control"
          onChange={handleChange}
          value={formData.description_en}
          required
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("description_ar")}</label>
        <input
          type="text"
          name="description_ar"
          className="form-control"
          onChange={handleArabicChange}
          value={formData.description_ar}
          required
        />
           {arabicError && (
                                    <div className="text-danger mt-1" style={{ fontSize: "0.9em" }}>
                                    {arabicError}
                                    </div>
                                )}
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("StartDate")}</label>
        <input
          type="date"
          name="start_date"
          className="form-control"
          onChange={handleChange}
          value={formData.start_date}
          required
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("StartTime")}</label>
        <input
          type="time"
          name="start_time"
          className="form-control"
          onChange={handleChange}
          value={formData.start_time}
          required
        />
      </div>
    </div>

   

    <div className="row">
    <div className="col-md-6 mb-3">
        <label className="form-label">{t("EndDate")}</label>
        <input
          type="date"
          name="end_date"
          className="form-control"
          onChange={handleChange}
          value={formData.end_date}
          required
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label">{t("Policytype")}</label>
        <select
          name="policy_type"
          className="form-select"
          onChange={handleChange}
          value={formData.type}
          required
        >
          <option value="">{t("SelectPolicyType")}</option>
          {policyTypes.map((typeItem, index) => (
            <option key={index} value={typeItem}>
              {typeItem}
            </option>
          ))}
        </select>
      </div>
    </div>

    <div className="text-end">
      <Button type="submit" disabled={isLoading}>
        {isLoading ? (
          <>
            <Spinner animation="border" size="sm" role="status" className="me-2" />
            {t("Update...")}
          </>
        ) : (
          t("UpdateComplianceCampaign")
        )}
      </Button>
    </div>
  </form>
</div>

  );
};

export default EditComplianceCampaign;
